<template>
	<el-form :disabled="onlyRead">
		<el-form-item label="数据类型:" label-width="120px">
			<el-tag>字符串</el-tag>
		</el-form-item>
		<el-form-item label="最大长度:" label-width="120px">
			<el-input v-model="specs.length"></el-input>
		</el-form-item>
	</el-form>
</template>

<script>
	export default {
		name: '',
		mixins: [],
		props: ['specs','onlyRead'],
		data() {
			return {}
		}
	}
</script>